import { memo, useContext } from 'react';
import styled from '@emotion/styled';
import { BrandInsightsModalContext, ChatViewType, ChatViewTypeContext } from '@trinity/chat-components/components/BrandInsights/context';
import { Link, type LinkProps } from '../presentation/Link';

type Props = LinkProps & {
  baseUrl?: string;
};

export const MessageCitationMaybeLink = memo(({ baseUrl, ...props }: Props) => {

  const chatViewType = useContext(ChatViewTypeContext);
  const [, toggleModal] = useContext(BrandInsightsModalContext);

  const handleClick = () => {
    if (chatViewType === ChatViewType.Modal) {
      toggleModal();
    }
  };

  if (!props.to) {
    return <>{props.children}</>;
  }

  const link = props.to.toString();

  const isAbsolute = link.startsWith('http');

  const absoluteUrl = isAbsolute
    ? link
    : baseUrl
      ? `${baseUrl}${link}`
      : null;

  if (absoluteUrl) {
    return (
      <StyledAnchor
        href={absoluteUrl}
        target="_blank"
        rel="noreferrer"
        onClick={handleClick}>
        {props.children}
      </StyledAnchor>
    );
  }

  return (
    <Root {...props} onClick={handleClick}>
      {props.children}
    </Root>
  );
});

const StyledAnchor = styled.a(({ theme }) => ({
  display: 'inline-flex',

  '&:hover div': {
    color: theme.palette.hyperlink,
    textDecoration: 'underline',
  },
}));

const Root = styled(Link)(({ theme }) => ({
  display: 'inline-flex',

  '&:hover div': {
    color: theme.palette.hyperlink,
    textDecoration: 'underline',
  },
}));
